module.exports = __webpack_public_path__ + "images/icons_v2/values-excellence-83a508c0.svg";